var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadbox flex-align-center"},[_c('div',{staticClass:"box"},[_c('figure',[_c('section',[_c('div')]),_c('section',[_c('div')]),_c('section',[_c('div')]),_c('section',[_c('div')]),_c('section',[_c('div')]),_c('section',[_c('div')]),_c('section',[_c('div')]),_c('section',[_c('div')])])])])
}]

export { render, staticRenderFns }